import m from "../../geodata/es2015/palestineLow";
window.am4geodata_palestineLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/palestineLow.js
// module id = null
// module chunks = 